import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ContactBookConfigurationService } from '../../services';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndexComponent implements OnInit, OnDestroy {
  public readonly configuration$ =
    this.contactBookConfigurationService.configuration$;

  constructor(
    private readonly contactBookConfigurationService: ContactBookConfigurationService
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}
}
